// Generated by https://quicktype.io

export enum PercentTypeListValue {
  Amount = 'Cantidad',
  Percentage = 'Porcentaje'
}

export enum PercentTypeListId {
  percent = '3BAFA0EE9F184CF3BA5A6F3C2341DC6B',
  amount = 'DF50255EB1954E39B05582FC2D3F70C7'
}

export interface PercentTypeList {
  id: string
  name: PercentTypeListValue
  selected: boolean
  value: PercentTypeListValue
}
